"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfBillingContactUpdateDto = instanceOfBillingContactUpdateDto;
exports.BillingContactUpdateDtoFromJSON = BillingContactUpdateDtoFromJSON;
exports.BillingContactUpdateDtoFromJSONTyped = BillingContactUpdateDtoFromJSONTyped;
exports.BillingContactUpdateDtoToJSON = BillingContactUpdateDtoToJSON;
exports.BillingContactUpdateDtoToJSONTyped = BillingContactUpdateDtoToJSONTyped;
const AddressCreateDto_1 = require("./AddressCreateDto");
/**
 * Check if a given object implements the BillingContactUpdateDto interface.
 */
function instanceOfBillingContactUpdateDto(value) {
    if (!('name' in value) || value['name'] === undefined)
        return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('address' in value) || value['address'] === undefined)
        return false;
    return true;
}
function BillingContactUpdateDtoFromJSON(json) {
    return BillingContactUpdateDtoFromJSONTyped(json, false);
}
function BillingContactUpdateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'name': json['name'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'address': (0, AddressCreateDto_1.AddressCreateDtoFromJSON)(json['address']),
    };
}
function BillingContactUpdateDtoToJSON(json) {
    return BillingContactUpdateDtoToJSONTyped(json, false);
}
function BillingContactUpdateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'name': value['name'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'address': (0, AddressCreateDto_1.AddressCreateDtoToJSON)(value['address']),
    };
}
//# sourceMappingURL=BillingContactUpdateDto.js.map